export default __webpack_public_path__ + "static/media/side-bar-banner.653de727.jpg";